import { render, staticRenderFns } from "./RefCategoryListAddNew.vue?vue&type=template&id=63aff0ae"
import script from "./RefCategoryListAddNew.vue?vue&type=script&lang=js"
export * from "./RefCategoryListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RefCategoryListAddNew.vue?vue&type=style&index=0&id=63aff0ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports